import { useState ,useEffect} from 'react';
import { withFormsy, addValidationRule } from 'formsy-react';
import { PatternFormat, NumericFormat } from 'react-number-format';
import DOMPurify from 'dompurify';
import "react-datepicker/dist/react-datepicker.css";
import { COUNTRY_CODE, COUNTRY_CODE_REGEX, ROUNDOFF_TO_MAX_LIMIT } from '../../config/constants';
import {Tooltip} from 'react-tippy';
import checkIcon from '../../webroot/images/icon.svg';

// Added common validation rule for all phone numbers
addValidationRule("isValidPhoneNumber", (values, value) => {
  if (value) {
    value = value.trim();
    if(value.includes(COUNTRY_CODE)) {
      value = value.replace(COUNTRY_CODE_REGEX, "").replace(/\s/g, "")
    }
    if (value[0] !== '9') return "Phone number must start with 9";
    if (value.length !== 10) return "Must be of 10 digits";
  }
  return true;
})

addValidationRule('isNegativeValue', function(values, value) {    
  if(value < 0) {
      return "Negative values are not allowed";
  }
  return true;
});
addValidationRule('isZeroValue', function(values, value) {  
  return value < 0 ? "Amount should be greater than zero" : true;
});

addValidationRule("isValidTelephonePhoneNumber", (values, value) => {
  if (value) {
    value = value.trim();
    if (value.length !== 11) return "Must be of 11 digits";
  }
  return true;
})

const FormsyInputField = (props) => {
    const [openTooltip, setOpenTooltip] = useState(null);
    const changeHandler = event => {
      const { value, id } = event.target;
      if (!props.errorMessage && value) {
        document.getElementById(id).style.border = "1px solid #bbbbbb";
      }
      if (typeof props.onChange === "function") {
        props.onChange(event);
      }
      if (props?.valueLength) {
        const trimmedValue = ROUNDOFF_TO_MAX_LIMIT(event.target.value, props?.valueLength)
        props.setValue(trimmedValue);
      }
      else {
        props.setValue(event.target.value);
      }
    };
    useEffect(() => {
      if (!props.isToolTipForWht && openTooltip === props.name) {
        setOpenTooltip(null);
      }
    }, [props.isToolTipForWht, props.name]);
    
    const patternFormatChangeHandler = (data) => {
      if (typeof props.onChange === "function") {
        props.onChange(data);
      }
      if (props?.valueLength) {
        const trimmedValue = ROUNDOFF_TO_MAX_LIMIT(data.value, props?.valueLength)
        props.setValue(trimmedValue);
      }
      else {
        props.setValue(data.value);
      }
    }
    
    const blurHandler = event => {
      const { value, id } = event.target;
      event.target.value = DOMPurify.sanitize(value);
      let errorElement = document
        .getElementById(id)
        .parentNode.querySelector(".error");
      if (props.isRequired && value === '') {
        document.getElementById(id).style.border = "1px solid red";
      }
      let formField = document.getElementById(id).closest(".form-field");
      if (value === "") {
        if (errorElement) errorElement.classList.remove("hide");
        if (formField) formField.classList.remove("active");
      } else {
        if (errorElement) errorElement.classList.add("hide");
        if (formField) formField.classList.add("active");
      }
    }

    const focusHandler = event => {
      const { id } = event.target;
      let formField = document.getElementById(id).closest(".form-field");
      if (formField) formField.classList.add("active");
    };

    let label = props.label;
    // To elipsize long label
    let labeltxtClass= (label && label.length && label.length >=80) && props.col!=="col-md-12" ? 'label-txt':'';
    if (props.isRequired || props.showAsterisk) label += " *";

    let Formatter = props.type === "pattern-format" ? PatternFormat : NumericFormat; 
    let decimalScale= props?.decimalScale ? props?.decimalScale : 2;
    return (
        <>
             {props.isSeparateLine && <div className="full-width-line"></div>}
            {["text", "password"].includes(props.type)? (
              <div class="material">
                <input
                  {...props}
                  autoComplete="new-off"
                  style={{ border: props.errorMessage ? "1px solid red" : "" }}
                  className={
                    props.className
                      ? props.className
                      : "form-input"
                  }
                  title={labeltxtClass ? label : ""}
                  onChange={changeHandler}
                  onBlur={blurHandler}
                  onFocus={focusHandler}
                  aria-label={label}
                />
                {props.errorMessage ? (
                  <div className="error-msg-txt">{props.errorMessage}</div>
                ) : (
                  ""
                )}
                <label data-label={label} class={`form-label ${labeltxtClass}`}></label>
                {props.isVerified && (
                  <img src={checkIcon} style={{ width: '15px', height: '15px', position: 'absolute', right: '10px', top: '15px' }} alt="verified" />
                )}
              </div>
            ) : ["pattern-format", "number-format"].includes(props.type) ? (
              <div class="material">
                <Formatter
                  {...props}
                  style={{ border: props.errorMessage ? "1px solid red" : "" }}
                  className={
                      props.className
                        ? props.className
                        : "form-input"
                    }
                  format={props.type === "pattern-format" ? props.format : null}
                  title={labeltxtClass ? label : ""}
                  onValueChange={(data,custom_event) => patternFormatChangeHandler(data, custom_event)}
                  onBlur={blurHandler}
                  allowEmptyFormatting
                  onFocus={focusHandler}
                  decimalScale={decimalScale}
                />
                {props.errorMessage ? (
                  <div className="error-msg-txt">{props.errorMessage}</div>
                ) : (
                  ""
                )}
                <label data-label={label} class={`form-label ${labeltxtClass}`}></label>
                {props.isVerified && (
                  <img src={checkIcon} style={{ width: '12px', height: '12px', position: 'absolute', right: '10px', top: '15px' }} alt="verified" />
                )}
                {(
                  ["vat_back_percent", "final_vat_back_amount"].includes(props.name) || 
                  (["di_amount_from_financier_to_carmudi_tax"].includes(props.name) && props.isToolTipForWht)
                ) && (
                  <i 
                    onClick={() => setOpenTooltip(prev => prev === props.name ? null : props.name)} 
                    className='ic-info-icon1 info-icon-input'>
                  </i>
                )}
                <Tooltip
                  html={
                    <div className="controlled-example tooltip-main">
                      <span className="controlled-example_close-button" onClick={() => setOpenTooltip(prev => prev === props.name ? null : props.name)}><i className="ic-clearclose"></i></span>
                      <p>
                        {props.name === "vat_back_percent"
                          ? "12% * (DI amount from Financer to Carmudi %(Gross))"
                          : props.name === "di_amount_from_financier_to_carmudi_tax"
                          ? "WHT is calculated on DI net of VAT amount (DI net of VAT = Gross DI / 1.12)"
                          : "VAT Back after WHT deduction (if applicable)"}
                      </p>
                    </div>
                  }
                  open={openTooltip === props.name}
                  tagName="span"
                  position="bottom"
                  trigger="manual"
                  interactive={true}
                  animateFill={false}
                  arrow={true}
                  arrowSize="small"
                  className="tooltip-outer"
                />
              </div>
            ) : null}
        </>
    )
}

export default withFormsy(FormsyInputField);